<template>
  <CommonContainer class="tutorial-article-container">
    <LazyCommonMarkDown
      :content="articleDetail.content"
      :title="articleDetail.title"
      :back-to-name="articleDetail?.categorys[0].name"
      :back-to-link="`/${$route.params.lang}/tutorial/`"
      has-back
      has-sub-nav
    ></LazyCommonMarkDown>
  </CommonContainer>
</template>

<script setup lang="ts">
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['tutorial-detail-page-cache-tag'])
})

interface Detail {
  id: number
  title: string
  image: string
  content: string
  content_html: string
  categorys: any[]
  recommend_list: any[]
}

const articleDetail = ref<Detail>({
  id: 0,
  title: '',
  image: '',
  content: '',
  content_html: '',
  categorys: [],
  recommend_list: []
})
const route = useRoute()
const tutorialStore = useTutorialStore()
const { fetchTutorialDetail } = tutorialStore
const { config } = storeToRefs(useStore())
articleDetail.value = await fetchTutorialDetail(~~route.params.id, config.value.id || 0, 1)
</script>

<style scoped lang="scss">
.tutorial-article-container {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 408px);
  margin: 80px auto 0;
  padding: 35px 0 0;
  &:deep(.app-markdown) {
    padding: 0;
  }
  &:deep(.app-markdown-inner) {
    padding: 0 108px 0 0;
  }
  &:deep(.app-markdown-inner.has__nav) {
    max-width: none;
  }
  //color: var(--theme-text-dark);

  @media not all and (min-width: 1024px) {
    & {
      margin: 120px 0 0 0;
      padding: 35px 0;
    }
    &:deep(.app-markdown-inner.has__nav) {
      max-width: 100%;
    }
    /* --- 移动端竖屏 --- */
    @media screen and (orientation: portrait) {
      & {
        background-image: url('@/assets/images/tutorial_texture.jpg');
      }
      //.tutorial-article-index {
      //  display: none;
      //}
    }
    /* --- 移动端横屏 --- */
    @media screen and (orientation: landscape) {
    }
  }
  @media all and (min-width: 1024px) {
    display: flex;
    justify-content: center;
  }
}
//.tutorial-article-wrapper {
//  width: 1440px;
//}
//
//.tutorial-article-content {
//  width: 1120px;
//  border-right: 1px solid #4d5158;
//
//  &-back {
//    width: 1070px;
//    display: flex;
//    align-items: center;
//
//    &-icon {
//      width: 20px;
//      height: 20px;
//      background: #363a41;
//      display: flex;
//      justify-content: center;
//      align-items: center;
//    }
//
//    &-topic {
//      font-size: 1rem;
//      line-height: 1.5;
//      color: #babec5;
//      margin-left: 18px;
//    }
//  }
//
//  &-divider {
//    width: 1070px;
//    height: 1px;
//    margin: 18px 0;
//    background-color: #2b2d32;
//  }
//
//  &-title {
//    width: 1070px;
//    font-size: 46px;
//    font-weight: 700;
//    line-height: 64px;
//    text-transform: uppercase;
//    color: #ffffff;
//
//    &::before {
//      content: '';
//      display: inline-block;
//      width: 8px;
//      height: 32px;
//      background: var(--theme-primary);
//      margin-right: 15px;
//    }
//  }
//
//  &-main {
//    width: 1070px;
//    padding: 14px 0 30px;
//    font-size: 1rem;
//    &:deep(h1) {
//      font-weight: 700;
//      font-size: 32px;
//      line-height: 48px;
//      color: #fff;
//    }
//    &:deep(h2) {
//      font-weight: 500;
//      font-size: 24px;
//      line-height: 34px;
//      color: #fff;
//    }
//    &:deep(h3) {
//      font-weight: 500;
//      font-size: 22px;
//      line-height: 30px;
//      color: #fff;
//    }
//    &:deep(h4) {
//      font-weight: 500;
//      font-size: 20px;
//      line-height: 28px;
//      color: #fff;
//    }
//    &:deep(p) {
//      font-weight: 400;
//      font-size: 16px;
//      color: #c8ccd3;
//      margin: 16px 0;
//    }
//    &:deep(img) {
//      max-width: 100%;
//      height: auto;
//      object-fit: contain;
//    }
//    &:deep(pre code) {
//      display: block;
//      padding: 24px;
//      width: 100%;
//      line-height: 1.5;
//      font-size: 0.9em;
//      color: #a6accd;
//      transition: color 0.5s;
//      background-color: #323232;
//      border-radius: 10px;
//      margin: 20px 0;
//      white-space: pre;
//      span {
//        color: #ffba00;
//      }
//    }
//    &:deep(code) {
//      margin: 0;
//      border-radius: 4px;
//      padding: 0.25rem 0.5rem;
//      font-family: 'GFF Latin', 'Helvetica Neue', 'Helvetica', 'Arial', 'Microsoft YaHei', '微软雅黑', 'sans-serif';
//      font-size: 0.85em;
//      background-color: #5c5f6d;
//      overflow: auto;
//    }
//    &:deep(a) {
//      text-decoration: underline;
//    }
//    &:deep(ol li) {
//      list-style-type: decimal;
//    }
//    &:deep(ul li) {
//      list-style-type: disc;
//    }
//    &:deep(ol),
//    &:deep(ul) {
//      margin: 1em 0;
//      line-height: 1.7;
//      padding-left: 1em;
//    }
//    /* Table */
//    &:deep(table) {
//      border-collapse: collapse;
//      width: 100%;
//      border: 1px solid #7a7e85;
//      margin-bottom: 20px;
//    }
//    //&:deep(table thead tr) {
//    //background-color: var(--table-thead-color);
//    //}
//
//    &:deep(table tr th) {
//      font-weight: bold;
//      border-left: 1px solid #7a7e85;
//      border-right: 1px solid #7a7e85;
//      text-align: left;
//      margin: 0;
//      padding: 6px 10px;
//      height: 40px;
//    }
//
//    &:deep(table tbody tr) {
//      border-top: 1px solid #7a7e85;
//      margin: 0;
//      padding: 0;
//    }
//
//    //table tbody tr:nth-child(2n) {
//    //background-color: var(--table-bg-darker-color);
//    //}
//
//    //table tbody tr:nth-child(2n + 1) {
//    //background-color: var(--table-bg-color);
//    //}
//
//    &:deep(table tr td) {
//      border-left: 1px solid #7a7e85;
//      border-right: 1px solid #7a7e85;
//      text-align: left;
//      margin: 0;
//      height: 40px;
//      padding: 6px 10px;
//    }
//
//    &:deep(table tr th:first-child, table tr td:first-child) {
//      border-left-width: 0;
//    }
//
//    &:deep(table tr th:last-child, table tr td:last-child) {
//      border-right-width: 0;
//    }
//    //&:deep(table) {
//    //  text-indent: 0;
//    //  border-color: inherit;
//    //  border-collapse: collapse;
//    //  width: 100%;
//    //}
//    //&:deep(table tr th) {
//    //  color: #fff;
//    //  font-size: 16px;
//    //  min-height: 40px;
//    //  padding: 6px 10px;
//    //}
//    //&:deep(table tr td) {
//    //  color: #c8ccd3;
//    //  min-height: 40px;
//    //  padding: 6px 10px;
//    //}
//    &:deep(blockquote) {
//      position: relative;
//      padding: 10px 20px;
//      background-color: #363a41;
//    }
//    &:deep(blockquote):before {
//      position: absolute;
//      top: 0;
//      left: 0;
//      width: 2px;
//      height: 100%;
//      background-color: #ffba00;
//    }
//    &:deep(video) {
//      width: 100%;
//      margin: 16px auto;
//    }
//    &:deep(iframe) {
//      width: 700px;
//      height: 394px;
//      display: block;
//      margin: 16px auto;
//      position: relative;
//    }
//    &:deep(hr) {
//      width: 100%;
//      border-top: 1px solid #2b2d32;
//    }
//  }
//
//  @media not all and (min-width: 1024px) {
//    /* --- 移动端竖屏 --- */
//    @media screen and (orientation: portrait) {
//      & {
//        width: 686px;
//        margin-right: 0;
//        border: none;
//      }
//      &-back {
//        width: 686px;
//      }
//      &-back-icon {
//        width: 28px;
//        height: 28px;
//      }
//      &-back-topic {
//        font-size: 24px;
//        line-height: 34px;
//      }
//      &-divider {
//        width: 100%;
//        margin: 7px 0;
//      }
//      &-title {
//        width: 100%;
//        font-size: 42px;
//        line-height: 54px;
//
//        &::before {
//          height: 30px;
//        }
//      }
//      &-main {
//        width: 100%;
//      }
//    }
//    /* --- 移动端横屏 --- */
//    @media screen and (orientation: landscape) {
//    }
//  }
//}
//
//.tutorial-article-index {
//  width: 280px;
//  padding-left: 52px;
//  position: fixed;
//  top: 115px;
//  right: 280px;
//
//  &-top {
//    margin-bottom: 9px;
//    font-weight: 700;
//    font-size: 18px;
//    line-height: 21.55px;
//    text-transform: uppercase;
//    color: #e8ecf3;
//  }
//
//  &-item {
//    font-size: 16px;
//    line-height: 40px;
//    font-weight: 400;
//    color: #c8ccd3;
//    text-transform: capitalize;
//    white-space: nowrap;
//
//    &.active {
//      color: var(--theme-primary);
//      position: relative;
//      display: flex;
//      align-items: center;
//
//      &::before {
//        position: absolute;
//        transform: translateX(-12px);
//        content: '';
//        display: inline-block;
//        width: 4px;
//        height: 13px;
//        background-color: var(--theme-primary);
//      }
//    }
//  }
//
//  @media only screen and (min-width: 1024px) and (max-width: 1535px) {
//    & {
//      right: 80px;
//    }
//  }
//}
</style>
